/**
 * PageSkeleton — S5-FE-04
 *
 * Lightweight loading fallback for React.lazy() route-level code splitting.
 * Used as Suspense fallback to avoid layout shift while chunks load.
 */
import { Skeleton } from "@/components/ui/skeleton";

export function PageSkeleton() {
  return (
    <div className="flex flex-col gap-4 p-6">
      {/* Header area */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-9 w-32" />
      </div>
      {/* Stat cards row */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-24 rounded-xl" />
        ))}
      </div>
      {/* Table placeholder */}
      <Skeleton className="h-[400px] rounded-xl" />
    </div>
  );
}
